import { Injectable, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { NewSnackbarService } from "./snackbar-new.service";
import { ErrorMessageComponent } from "../ffwd/components/error-message/error-message.component";
import { InfoMessageComponent } from "../ffwd/components/info-message/info-message.component";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);
  private readonly translateService = inject(TranslateService);
  private snackbar = inject(NewSnackbarService);

  /**
   * Opens a snackbar
   * @param message
   * @param action
   */
  public open(message: string, duration = 5000) {
    this.snackbar.open<string>(InfoMessageComponent, message, undefined, { duration });
  }

  public error() {
    this.snackbar.open<string>(ErrorMessageComponent, this.translateService.instant("COMPONENTS.EVERYWHERE.ERROR.GENERIC"));
  }
}
